export const PROFILE_CONFIRM_EMAIL = 'profile/confirmEmail';
export const PROFILE_CONFIRM_RESET_PASSWORD = 'profile/confirmResetPassword';
export const PROFILE_CHANGE_PASSWORD = 'profile/changePassword';
export const PROFILE_RESEND_CONFIRM_EMAIL = 'profile/resendConfirmEmail';
